import React from "react"
import logo from "./images/logo-edison.svg"

const Introduzione = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="h-100 grid-cols-6 xl:grid-cols-12">
      <div className='col-1'>
        {/* <Menu /> */}
      </div>
      <div className='col-2'>
        <svg className="mt-13">
          <text
            x={0}
            y={0}
            transform="rotate(-90) translate(0 16)"
            className='font-16 line-height-20'
            textAnchor="end"
            fill={color}
          >
            APRILE 2020
          </text>
        </svg>
        {/* <div className='font-16 line-height-20 mt-13' style={{ transform: "rotate(180deg)", writingMode: 'vertical-rl'}}>MARZO 2020</div> */}
      </div>
      <div className='col-6'>
        <div className='lg:mt-8 xl:mt-6 lg:font-18 xl:font-16'>Introduzione</div>
        <p className='mt-2 lg:font-24 xl:font-20 line-height-32 font-family-acumin'>
          I livelli preoccupanti di inquinamento atmosferico
          e lo sfruttamento delle risorse petrolifere obbligano
          a intervenire, con soluzione concrete, nel dibattito
          sulla convenienza dei mezzi di trasporto alimentati
          a combustibili fossili.
        </p>
        <p className='mt-3 lg:font-24 xl:font-20 line-height-32 font-family-acumin'>
          La cosiddetta mobilità alternativa è diventata
          una necessità, non più solo una tendenza:
          cambiare il modo di muoversi, a tutti i livelli,
          oggi è doveroso per contribuire a un migliore
          utilizzo delle risorse.
        </p>
        <p className='mt-3 lg:font-24 xl:font-20 line-height-32 font-family-acumin'>
          Per questo Edison ha sviluppato Fleet Audit,
          servizio che favorisce la mobilità sostenibile attraverso 
          l'analisi delle flotte e la successiva
          graduale elettrificazione.
        </p>
        <p className='lg:mt-9 xl:mt-7 font-14 text-orange blink-text font-family-neun'>
          SCROLL DOWN
        </p>
      </div>
      <div className='col-3 lg:mt-8 xl:mt-7 text-center'>
        <img src={logo} alt='Edison' />
      </div>
    </div>
  )
}

export default Introduzione
